<div class="detail-dexterity">
  <div class="data-chart mb-6">
    <div
      class="d-flex flex-wrap justify-content-between align-items-center mb-3 ms-xxl-6 me-xxl-4"
    >
      <h1 class="fs-2 me-3 my-1">
        <ng-container
          *appSkeletonLoader="
            loading;
            style: { height: '2.5rem', width: '10rem' }
          "
        >
          <span i18n="@@patient_evaluationDexterity_title">Dexterity</span>
        </ng-container>
      </h1>
      <form [formGroup]="dateRangeForm">
        <div class="data-chart__filter row align-items-center my-1">
          <div class="col-auto pe-0">
            <ng-container
              *appSkeletonLoader="
                loading;
                style: { height: '2.5rem', width: '1.8rem' }
              "
            >
              <label
                for="startDate"
                class="col-form-label fw-semi-bold text-gray-70"
                i18n="@@patient_evaluation_fromLabel"
                >From</label
              >
            </ng-container>
          </div>
          <div class="col-auto">
            <div class="form-group">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '2.5rem', width: '8rem' }
                "
              >
                <div
                  class="input-group"
                  ngbDropdown
                  #dropdownStartDate="ngbDropdown"
                  autoClose="outside"
                  placement="bottom-right"
                >
                  <input
                    type="text"
                    class="form-control form-control--monthpicker bg-white"
                    placeholder="MM/AAAA"
                    i18n-placeholder="@@patient_evaluation_fromPlaceholder"
                    name="startDate"
                    formControlName="startDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('startDate').invalid &&
                        !dateRangeForm.get('startDate').pristine
                    }"
                  />
                  <button
                    type="button"
                    class="dropdown-toggle-split"
                    id="dropdownStartDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('startDate').invalid &&
                        !dateRangeForm.get('startDate').pristine
                    }"
                    ngbDropdownToggle
                  >
                    <img
                      src="assets/icons/icon_calendar.svg"
                      class="img-fluid"
                      alt="calendar"
                    />
                  </button>
                  <div
                    ngbDropdownMenu
                    class="p-0"
                    aria-labelledby="dropdownStartDate"
                  >
                    <app-monthpicker
                      (selected)="
                        changeDateRange($event, 'startDate');
                        dropdownStartDate.close()
                      "
                      [year]="getDateYear('startDate')"
                      [month]="getDateMonth('startDate')"
                    ></app-monthpicker>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-auto px-0">
            <ng-container
              *appSkeletonLoader="
                loading;
                style: { height: '2.5rem', width: '1.8rem' }
              "
            >
              <label
                for="endDate"
                class="col-form-label fw-semi-bold text-gray-70"
                i18n="@@patient_evaluation_toLabel"
                >to</label
              >
            </ng-container>
          </div>
          <div class="col-auto">
            <div class="form-group">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '2.5rem', width: '7rem' }
                "
              >
                <div
                  class="input-group"
                  ngbDropdown
                  #dropdownEndDate="ngbDropdown"
                  autoClose="outside"
                  placement="bottom-right"
                >
                  <input
                    class="form-control form-control--monthpicker bg-white"
                    placeholder="MM/AAAA"
                    i18n-placeholder="@@patient_evaluation_toPlaceholder"
                    id="endDate"
                    formControlName="endDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('endDate').invalid &&
                        !dateRangeForm.get('endDate').pristine
                    }"
                  />
                  <button
                    type="button"
                    class="dropdown-toggle-split"
                    id="dropdownEndDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('endDate').invalid &&
                        !dateRangeForm.get('endDate').pristine
                    }"
                    ngbDropdownToggle
                  >
                    <img
                      src="assets/icons/icon_calendar.svg"
                      class="img-fluid"
                      alt="calendar"
                    />
                  </button>
                  <div
                    ngbDropdownMenu
                    class="p-0"
                    aria-labelledby="dropdownEndDate"
                  >
                    <app-monthpicker
                      (selected)="
                        changeDateRange($event, 'endDate');
                        dropdownEndDate.close()
                      "
                      [year]="getDateYear('endDate')"
                      [month]="getDateMonth('endDate')"
                    ></app-monthpicker>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="data-chart__left-hand mt-5">
      <h3 class="fs-5 ms-xxl-7">
        <ng-container
          *appSkeletonLoader="
            loadingChart;
            style: { height: '2.3rem', width: '12rem' }
          "
        >
          <span i18n="@@patient_evaluationDexterity_leftHandTitle"
            >Left hand</span
          >
        </ng-container>
      </h3>
      <app-chart
        [loading]="loadingChart"
        [chartDatasets]="leftHandDatasets"
        [chartXLabels]="xLabels"
        [chartHorizontalLimitLines]="evaluation.horizontalLimitLines"
        (toggledFeatureDisplay)="updateChartDescriptionFeature($event)"
      ></app-chart>
    </div>
    <div class="data-chart__right-hand mt-8">
      <h3 class="fs-5 ms-xxl-7">
        <ng-container
          *appSkeletonLoader="
            loadingChart;
            style: { height: '2.3rem', width: '12rem' }
          "
        >
          <span i18n="@@patient_evaluationDexterity_rightHandTitle"
            >Right hand</span
          >
        </ng-container>
      </h3>
      <app-chart
        [loading]="loadingChart"
        [chartDatasets]="rightHandDatasets"
        [chartXLabels]="xLabels"
        [chartHorizontalLimitLines]="evaluation.horizontalLimitLines"
        (toggledFeatureDisplay)="updateChartDescriptionFeature($event)"
      ></app-chart>
    </div>
  </div>
  <div class="py-4">
    <ngb-accordion #a="ngbAccordion" activeIds="desc_test, desc_situation">
      <ngb-panel id="desc_test">
        <ng-template ngbPanelHeader>
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="m-0">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '1.6rem', width: '10rem' }
                "
              >
                <span i18n="@@patient_evaluation_evaluationDescriptionTitle"
                  >Evaluation description</span
                >
              </ng-container>
            </h3>
            <div>
              <ng-container
                *appSkeletonLoader="
                  loading;
                  type: 'circle';
                  style: { height: '2.6rem', width: '2.6rem' }
                "
              >
                <button ngbPanelToggle class="btn btn-link p-0">
                  <img
                    [src]="
                      a.isExpanded('desc_test')
                        ? 'assets/icons/icon-dropdown-close.svg'
                        : 'assets/icons/icon-dropdown-open.svg'
                    "
                    alt="icon"
                  />
                </button>
              </ng-container>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="content-card">
            <ng-container
              *appSkeletonLoader="loading; style: { height: '12rem' }"
            >
              <div>
                <u i18n="@@patient_evaluation_evaluationDescriptionContentTitle"
                  >Principe de l’évaluation :</u
                >
                <br />
                <p
                  i18n="
                    @@patient_evaluationDexterity_evaluationDescriptionContentP1"
                >
                  Ce test consiste à évaluer la coordination œil-main d'un
                  patient dans le temps. Ce test est basé sur le 9-Hole Peg Test
                  (9-HPT).
                </p>
                <p
                  i18n="
                    @@patient_evaluationDexterity_evaluationDescriptionContentP2"
                >
                  Pour chaque main (ou pour la main valide), les patients
                  doivent suivre six tracés géométriques de référence en
                  déplaçant leur doigt sur l'écran du smartphone du point de
                  départ au point d'arrivée dutracé de référence.
                </p>
                <p
                  i18n="
                    @@patient_evaluationDexterity_evaluationDescriptionContentP3"
                >
                  Les patients doivent faire un compromis vitesse/précision
                  pendant le test :<br />
                  rester le plus près possible du tracé de référence tout en
                  allant le plus rapidement possible. Les patients doivent
                  s'arrêter le plus précisément possible sur le point final du
                  tracé.
                </p>
              </div>
              <div>
                <u
                  i18n="
                    @@patient_evaluation_evaluationDescriptionConditionTitle"
                  >Condition de validité du test :>Condition de validité des
                  résultats :</u
                >
                <br />
                <p
                  i18n="
                    @@patient_evaluationDexterity_evaluationDescriptionConditionContent"
                >
                  Le test sera considéré comme valide si le patient réalise
                  toutes les formes pour la ou les mains sélectionnées. Si le
                  patient quitte le test de lui-même, le test est considéré
                  comme non valide et les résultats ne seront pas enregistrés.
                </p>
              </div>
              <div>
                <u i18n="@@patient_evaluation_evaluationDescriptionResultTitle"
                  >Résultats : </u
                ><br />
                <span
                  i18n="
                    @@patient_evaluationDexterity_evaluationDescriptionResultContent"
                  >Les données recueillies permettent de fournir les
                  informations suivantes :</span
                >
                <ul class="list">
                  <li
                    i18n="
                      @@patient_evaluationDexterity_evaluationDescriptionResultLi1"
                  >
                    Écart moyen par rapport aux tracés (en mm)
                  </li>
                  <li
                    i18n="
                      @@patient_evaluationDexterity_evaluationDescriptionResultLi2"
                  >
                    Durée de tracé moyen (en s)
                  </li>
                  <li
                    i18n="
                      @@patient_evaluationDexterity_evaluationDescriptionResultLi3"
                  >
                    Vitesse de tracé (en cm/s)
                  </li>
                </ul>
              </div>
            </ng-container>
          </div>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="desc_situation">
        <ng-template ngbPanelHeader let-opened="opened">
          <div
            class="d-flex align-items-center justify-content-between line-top"
          >
            <h3 class="m-0">
              <ng-container
                *appSkeletonLoader="
                  loadingChart;
                  style: { height: '1.6rem', width: '10rem' }
                "
              >
                <span i18n="@@patient_evaluation_situationDescriptionTitle"
                  >Situation description</span
                >
              </ng-container>
            </h3>
            <div>
              <ng-container
                *appSkeletonLoader="
                  loadingChart;
                  type: 'circle';
                  style: { height: '2.6rem', width: '2.6rem' }
                "
              >
                <button ngbPanelToggle class="btn btn-link p-0">
                  <img
                    [src]="
                      a.isExpanded('desc_situation')
                        ? 'assets/icons/icon-dropdown-close.svg'
                        : 'assets/icons/icon-dropdown-open.svg'
                    "
                    alt="icon"
                  />
                </button>
              </ng-container>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="content-card">
            <ng-container
              *appSkeletonLoader="loadingChart; style: { height: '12rem' }"
            >
              <app-chart-description
                [startDate]="dateRangeForm.get('startDate').value"
                [endDate]="dateRangeForm.get('endDate').value"
                [patient]="patientProfile"
                [xLabels]="xLabels"
                [chartDescription]="chartDescription"
              ></app-chart-description>
            </ng-container>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>
